import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { AppProvider, useApp } from './context/AppContext';
import { AppNavigator } from './navigation/AppNavigator';
import { ToastProvider } from './components/ToastNotification';
import { lightTheme, darkTheme } from './theme/theme';
import { applyTextSizeToDocument, writeStoredTextSize } from './utils/textSize';

function AppContent() {
  const { state } = useApp();
  const theme = state.theme === 'dark' ? darkTheme : lightTheme;
  
  // Update document data-theme attribute for CSS variables
  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', state.theme);
  }, [state.theme]);

  React.useEffect(() => {
    applyTextSizeToDocument(state.textSize);
    writeStoredTextSize(state.textSize);
  }, [state.textSize]);

  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <AppNavigator />
      </ToastProvider>
    </ThemeProvider>
  );
}

function App() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default App;
